import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import { openCookiePreferences } from "@/components/site/CookieBanner";

export default function Footer({ content, settings }) {
    const { t, pick } = useI18n();
    const f = content?.footer || {};
    return (
        <footer data-testid="site-footer" className="bg-[#0F172A] text-white relative">
            <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid gap-10 md:grid-cols-3">
                <div>
                    <Link to="/" className="inline-flex items-center" aria-label="BA Media Performance home">
                        <picture>
                            <source srcSet="/bamedia-logo.webp" type="image/webp" />
                            <img
                                src="/bamedia-logo.png"
                                alt="BA Media Performance"
                                width="200"
                                height="200"
                                decoding="async"
                                className="h-28 w-28 sm:h-32 sm:w-32 object-contain"
                                loading="lazy"
                            />
                        </picture>
                    </Link>
                    <p className="mt-5 text-white/65 text-sm leading-relaxed max-w-sm">
                        {pick(f.tagline)}
                    </p>
                </div>

                <div className="grid grid-cols-2 gap-6 text-sm">
                    <div>
                        <div className="text-[11px] uppercase tracking-[0.22em] text-white/60 font-semibold mb-3">{t("footer.services")}</div>
                        <ul className="space-y-2 text-white/80">
                            <li><a href="/#leistungen">Lead Funnels</a></li>
                            <li><a href="/#leistungen">Google Ads</a></li>
                            <li><a href="/#leistungen">Meta Ads</a></li>
                            <li><a href="/#leistungen">WhatsApp Funnel</a></li>
                            <li><a href="/#leistungen">Automationen</a></li>
                        </ul>
                    </div>
                    <div>
                        <div className="text-[11px] uppercase tracking-[0.22em] text-white/60 font-semibold mb-3">{t("footer.company")}</div>
                        <ul className="space-y-2 text-white/80">
                            <li><a href="/#projekte">Projekte</a></li>
                            <li><a href="/#faq">FAQ</a></li>
                            <li><a href="/#kontakt">Kontakt</a></li>
                            <li><a href="/login" data-testid="footer-client-portal-link">Kundenbereich</a></li>
                            <li><Link to="/admin/login" data-testid="footer-admin-link">Admin</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="text-sm">
                    <div className="text-[11px] uppercase tracking-[0.22em] text-white/60 font-semibold mb-3">{t("footer.contact")}</div>
                    <div className="text-white/80 space-y-1">
                        <div>kontakt@bamediaperformance.com</div>
                        <div>WhatsApp: +49 152 31656312</div>
                        <div>Tel: +49 152 31656312</div>
                        <div className="mt-3 text-white/55 text-xs leading-relaxed">
                            Obernburger Str. 125<br />
                            63811 Stockstadt a. Main<br />
                            Deutschland
                        </div>
                    </div>
                </div>
            </div>

            <div className="border-t border-white/10">
                <div className="max-w-7xl mx-auto px-5 lg:px-8 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/55">
                    <div>
                        © {new Date().getFullYear()} {f.company || "BA-INTERNATIONAL-MANAGEMENT GMBH"} · USt-IdNr. {f.vat || "DE325226719"} ·
                        <span className="ml-1">{f.legal_note || "BA Media Performance ist eine Marke der BA-INTERNATIONAL-MANAGEMENT GMBH."}</span>
                    </div>
                    <div className="flex flex-wrap gap-4">
                        <Link to="/impressum" data-testid="footer-imprint-link" className="hover:text-white">{t("footer.imprint")}</Link>
                        <Link to="/datenschutz" data-testid="footer-privacy-link" className="hover:text-white">{t("footer.privacy")}</Link>
                        <button
                            type="button"
                            onClick={openCookiePreferences}
                            data-testid="footer-cookie-prefs-link"
                            className="hover:text-white"
                        >
                            Cookie-Einstellungen
                        </button>
                    </div>
                </div>
            </div>
        </footer>
    );
}
